import * as amplitude from '@amplitude/analytics-browser'

import type { Session } from 'types/Session'
import Environment from 'helpers/environment'
import { dealerAnalyticsAttributes } from 'helpers/analyticsAttributes'

class Amplitude {
  static session: Session | null = null
  static brand: string | undefined = undefined

  static apiKey() {
    if (Environment.isProduction()) {
      return '9915ff7cd2acb116142ed004334d392d'
    } else if (Environment.isStaging()) {
      return '48bbd425cb95b6f8776411cd15ce75d8'
    } else if (Environment.isQA()) {
      return '7a69edc6d96eb95432516ace5c1ddb7a'
    } else if (Environment.isQA2() || Environment.isDevelopment()) {
      return 'e4198b636a8a517aa970f2c211281f7d'
    } else {
      return ''
    }
  }

  //An enrichment plugin is the only hook that reaches the events Amplitude tracks 
  // itself (session start/end, page views), so the dealer attributes are stamped here.
  static DWAEnrichmentPlugin(): amplitude.Types.EnrichmentPlugin {
    return {
      name: 'dwa-enrichment',
      type: 'enrichment',
      execute: async (event) => {
        if (!Amplitude.session) return event

        return {
          ...event,
          event_properties: {
            ...event.event_properties,
            ...dealerAnalyticsAttributes(Amplitude.session, Amplitude.brand)
          }
        }
      }
    }
  }

  static init(session?: Session | null, brand?: string) {
    const apiKey = Amplitude.apiKey()

    if (!apiKey) return

    if (session) {
      Amplitude.session = session
      Amplitude.brand = brand

      amplitude.add(Amplitude.DWAEnrichmentPlugin())
    }

    amplitude.init(apiKey, {
      defaultTracking: {
        sessions: true,
        pageViews: true
      },
      logLevel: Environment.isProduction() ? amplitude.Types.LogLevel.Warn : amplitude.Types.LogLevel.Debug
    })
  }

  // The dealer attributes are stamped by the enrichment plugin, so only the
  // event specific properties are passed along here.
  static track(eventName: string, eventProperties?: Record<string, unknown>) {
    if (!Amplitude.apiKey()) return

    amplitude.track(eventName, eventProperties)
  }
}

export default Amplitude
